/**
 * @file 统一全局顶部 Toast 提示
 * @date 2021-07-12
 */

import { ElMessage } from 'element-plus';
import { CircleCloseFilled, SuccessFilled } from '@element-plus/icons-vue';

let current = null;

/**
 * 失败提示
 *
 * @param {(Object|string)} message 配置参数或者通知的消息
 * @return {Message}
 * @example
 * 1. 字符串形式
 * error('message');
 * 2. 对象形式
 * error({ message });
 */
export function error(message) {
    if (window.sfe.prerender) return current;
    const options = typeof message === 'object' ? message : { message };
    // message为空阻止弹出
    if (!options.message) return current;
    if (current) current.close();
    current = ElMessage({
        type: '404', // 这里主要下面自定的 `iconClass` 优先级没有 `el-icon-$type` 高，这里写个不存在的
        customClass: 'sfe-toast sfe-toast-error',
        icon: CircleCloseFilled,
        duration: 3000,
        offset: 8,
        ...options,
    });
    return current;
}

/**
 * 成功提示
 *
 * @param {(Object|string)} message 配置参数或者通知的消息
 * @return {Message}
 * @example
 * 1. 字符串形式
 * success('message');
 * 2. 对象形式
 * success({ message });
 */
export function success(message) {
    if (window.sfe.prerender) return current;
    const options = typeof message === 'object' ? message : { message };
    if (current) current.close();
    current = ElMessage({
        customClass: 'sfe-toast sfe-toast-success',
        icon: SuccessFilled,
        duration: 3000,
        offset: 8,
        ...options,
    });
    return current;
}

/**
 * info 提示
 *
 * @param {(Object|string)} message 配置参数或者通知的消息
 * @return {Message}
 * @example
 * 1. 字符串形式
 * info('message');
 * 2. 对象形式
 * info({ message });
 */
export function info(message) {
    if (window.sfe.prerender) return current;
    const options = typeof message === 'object' ? message : { message };
    if (current) current.close();
    current = ElMessage({
        customClass: 'sfe-toast sfe-toast-info',
        duration: 3000,
        offset: 8,
        ...options,
    });
    return current;
}
